import React from "react";
import Modal from "../Modal/Modal";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const customCancelButtonStyles = () => ({
  root: {
    backgroundColor: "#efefef",
    color: "#000",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#d4d4d4",
      boxShadow: "none"
    }
  }
});

const customSubmitButtonStyles = () => ({
  root: {
    backgroundColor: "var(--color-main)",
    color: "#fff",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#000",
      boxShadow: "none"
    }
  }
});

const CustomSubmitButton = withStyles(customSubmitButtonStyles)(Button);
const CustomCancelButton = withStyles(customCancelButtonStyles)(Button);

const TelefonInfoModal = props => {
  const { modalToggled, toggleModal, selectedClinic } = props;

  const handleCancel = () => {
    toggleModal();
  };

  const handleSubmit = () => {
    window.location.href = "tel:+4912345678";
    toggleModal();
  };

  return (
    <div>
      <Modal modalToggled={modalToggled} toggleModal={toggleModal} hasClosingButton={true}>
        {/* TODO: Make dynamic */}
        <h1>Hinweis</h1>

        {!selectedClinic.emergencyTelInfo ? (
          <div>
            <p>Diese Praxis/Klinik wünschen keine telefonische Voranmeldung für Notfälle.</p>
            <p>
              Kleintierpraxen/-kliniken, die weder eine Telefonnummer angegeben haben, noch eine
              digitale Voranmeldung unterstützen, kannst Du ohne Voranmeldung direkt aufsuchen.
            </p>
          </div>
        ) : (
          <div>
            <p>
              Mit dieser Funktion kannst Du direkt einen Anruf starten, um deinen Besuch im
              Notdienst der Kleintierpraxis/-klinik anzukündigen. Bitte habe Verständnis dafür, dass
              eine telefonische Beratung im Notdienst nicht möglich ist.
            </p>
            <p>
              Sollte keine Telefonnummer angezeigt werden oder ist die Telefonleitung besetzt, nutze
              unsere digitale Voranmeldung.
            </p>
          </div>
        )}

        <div className="sendingFormDataModal__Buttons">
          <CustomCancelButton
            className="sendingFormDataModal__Buttons--cancel"
            size="small"
            variant="contained"
            onClick={handleCancel}
            type="submit"
          >
            Abbrechen
          </CustomCancelButton>
          {selectedClinic.emergencyTelInfo ? (
            <CustomSubmitButton
              className="sendingFormDataModal__Buttons--continue"
              size="small"
              variant="contained"
              color="primary"
              type="submit"
              onClick={handleSubmit}
            >
              Klinik Anrufen
            </CustomSubmitButton>
          ) : (
            <CustomSubmitButton
              className="sendingFormDataModal__Buttons--continue"
              size="small"
              variant="contained"
              color="primary"
              type="submit"
              onClick={toggleModal}
            >
              Schließen
            </CustomSubmitButton>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default TelefonInfoModal;
